<template>
    <vue-modal
        v-model="isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="false"
        :modalBodyClass="$prefixClass.modal + '-optimize-actual'"
    >
        <vue-optimize-content @start-optimize="startOptimize"></vue-optimize-content>
    </vue-modal>
</template>
<script>
export default {
    name: "ModalOptimizeActual",
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        isVisible: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        }
    },
    methods: {
        startOptimize() {
            this.isVisible = false
            this.$emit('let-start-optimize')
        }
    }
}
</script>
<style lang="scss">
    .m-modal {
        &-content {
            border-radius: 8px;
        }
        &-optimize-actual {
            text-align: center;
            width: 790px !important;
            .m-modal {
                &-body {
                    padding: 32px 0;
                }
            }
        }
    }
</style>
